"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePasskeySession = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const bu_account_types_1 = require("../bu_account_types");
const AccountService_1 = require("../AccountService");
const AccountSession_1 = require("./AccountSession");
function findVerifyItem(mfaParams, verify_type) {
    return mfaParams.verify_items.find((item) => item.items.some((item) => item.verify_type === verify_type));
}
class BasePasskeySession extends AccountSession_1.AccountSession {
    constructor(params, action) {
        super(params, action);
        this.verifySecurityAccount = (mfaParams, verify_failed) => {
            const sms = findVerifyItem(mfaParams, "sms");
            const email = findVerifyItem(mfaParams, "email");
            const google = findVerifyItem(mfaParams, "google");
            const verifyTypes = [];
            const maskAccounts = [];
            if (sms) {
                verifyTypes.push(AccountSession_1.VerifyType.sms_code);
                maskAccounts.push({
                    account_type: bu_account_types_1.AccountType.phoneNumber,
                    account_value: sms.items[0].target_mask || "",
                });
            }
            if (email) {
                verifyTypes.push(AccountSession_1.VerifyType.email_code);
                maskAccounts.push({
                    account_type: bu_account_types_1.AccountType.email,
                    account_value: email.items[0].target_mask || "",
                });
            }
            if (google) {
                verifyTypes.push(AccountSession_1.VerifyType.verify_otp);
            }
            if (verifyTypes.length === 0) {
                return (0, rxjs_1.of)({});
            }
            return new rxjs_1.Observable((subscriber) => {
                this.params.requestVerifyData({
                    action: this.action,
                    txn_id: mfaParams.txn_id,
                    verifyTypes: verifyTypes,
                    paramData: {
                        maskAccounts,
                    },
                    codeIds: {},
                    verify_failed,
                    callback: (data) => {
                        const params = {
                            txn_id: mfaParams.txn_id,
                            usage: this.action,
                        };
                        if (data["otp_code"]) {
                            params.google_code = data["otp_code"];
                        }
                        if (data["sms_code"]) {
                            params.sms_code = data["sms_code"];
                            params.sms_code_id = data["sms_code_id"];
                        }
                        if (data["voice_code"]) {
                            params.voice_code = data["voice_code"];
                            params.voice_code_id = data["voice_code_id"];
                        }
                        if (data["email_code"]) {
                            params.email_code = data["email_code"];
                            params.email_code_id = data["email_code_id"];
                        }
                        AccountService_1.AccountService.verifyVerifyCode(params).subscribe({
                            next: (data) => {
                                subscriber.next(data);
                            },
                            error: (err) => {
                                this.verifySecurityAccount(mfaParams, err).subscribe({
                                    next: (data) => {
                                        subscriber.next(data);
                                    },
                                });
                            },
                        });
                    },
                });
            });
        };
        this.verifyBiometric = (mfaParams) => {
            var _a, _b, _c;
            const faceId = this.findVerifyItemIgnoreCase(mfaParams, AccountSession_1.BiometricType.FaceId);
            const touchId = this.findVerifyItemIgnoreCase(mfaParams, AccountSession_1.BiometricType.TouchId);
            const passcode = this.findVerifyItemIgnoreCase(mfaParams, AccountSession_1.BiometricType.Passcode);
            const verifyTypes = [];
            let nonce = "";
            let type = "";
            if (faceId && faceId.items.length > 0) {
                verifyTypes.push(AccountSession_1.VerifyType.verify_FaceId);
                nonce = (_a = faceId.items[0].nonce) !== null && _a !== void 0 ? _a : "";
                type = AccountSession_1.BiometricType.FaceId;
            }
            else if (touchId && touchId.items.length > 0) {
                verifyTypes.push(AccountSession_1.VerifyType.verify_TouchId);
                nonce = (_b = touchId.items[0].nonce) !== null && _b !== void 0 ? _b : "";
                type = AccountSession_1.BiometricType.TouchId;
            }
            else if (passcode && passcode.items.length > 0) {
                verifyTypes.push(AccountSession_1.VerifyType.verify_Passcode);
                nonce = (_c = passcode.items[0].nonce) !== null && _c !== void 0 ? _c : "";
                type = AccountSession_1.BiometricType.Passcode;
            }
            if (verifyTypes.length === 0) {
                return (0, rxjs_1.of)({});
            }
            return new rxjs_1.Observable((subscriber) => {
                this.params.requestVerifyData({
                    action: this.action,
                    txn_id: mfaParams.txn_id,
                    verifyTypes: verifyTypes,
                    paramData: {
                        nonce: nonce,
                        type: type.toLowerCase(),
                    },
                    codeIds: {},
                    callback: (data) => {
                        var _a;
                        AccountService_1.AccountService.verifyBiometric({
                            txn_id: mfaParams.txn_id,
                            usage: this.action,
                            type: (_a = data["biometric_type"]) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                            signature: data["biometric_signature"],
                        }).subscribe({
                            next: (data) => {
                                subscriber.next(data);
                            },
                            error: (err) => {
                                subscriber.error(err);
                            },
                        });
                    },
                });
            });
        };
        this.verifyPasskeyOrBiometrics = (mfaParams) => {
            const passkey = this.findVerifyItemIgnoreCase(mfaParams, "passkey");
            if (!passkey) {
                return this.verifyBiometric(mfaParams);
            }
            return AccountService_1.AccountService.fetchPasskeyParams({ txn_id: mfaParams.txn_id, usage: this.action }).pipe((0, operators_1.mergeMap)((paramsData) => {
                return (0, rxjs_1.of)(0).pipe((0, operators_1.mergeMap)(() => {
                    if (this.params.requestPasskey) {
                        return this.params.requestPasskey(paramsData.params, mfaParams.txn_id);
                    }
                    else {
                        return (0, rxjs_1.throwError)({ message: "AccountSession requestPasskey not config" });
                    }
                }), (0, operators_1.mergeMap)((passkeyResult) => {
                    return AccountService_1.AccountService.verifyPasskey({
                        txn_id: mfaParams.txn_id,
                        request_id: paramsData.request_id,
                        params: passkeyResult,
                        usage: this.action,
                    });
                }));
            }));
        };
    }
    findVerifyItemIgnoreCase(mfaParams, verify_type) {
        return mfaParams.verify_items.find((item) => item.items.some((item) => item.verify_type.toLowerCase() === verify_type.toLowerCase()));
    }
    verifyCaptcha(mfaParams) {
        const captcha = mfaParams.verify_items.find((item) => item.items.some((item) => item.verify_type === "captcha"));
        if (!captcha) {
            return (0, rxjs_1.of)({});
        }
        return AccountService_1.AccountService.getCaptchaData({ usage: this.action, txn_id: mfaParams.txn_id }).pipe((0, operators_1.mergeMap)((captchaData) => {
            return (0, rxjs_1.of)(0).pipe((0, operators_1.mergeMap)(() => {
                if (this.params.requestGtCaptcha) {
                    const captcha_data = JSON.parse(captchaData.captcha_data);
                    return this.params.requestGtCaptcha({
                        captchaId: captcha_data.gt,
                        riskType: captcha_data.risk_type,
                        lang: this.params.lang,
                    });
                }
                else if (this.params.requestCaptcha) {
                    return this.params.requestCaptcha(captchaData.captcha_data);
                }
                else {
                    return (0, rxjs_1.throwError)({ message: "AccountSession requestGtCaptcha not config" });
                }
            }), (0, operators_1.mergeMap)((captchaResult) => {
                return AccountService_1.AccountService.verifyCaptcha({
                    txn_id: mfaParams.txn_id,
                    request_id: captchaData.request_id,
                    usage: this.action,
                    captcha_data: captchaResult,
                });
            }));
        }));
    }
    startSession(requestExecutor, txn_id, ext) {
        this.subscription = AccountService_1.AccountService.generatePasskeyMfaParams({
            usage: this.action,
            biometric_key_md5: this.params.biometricKeyMd5,
            ext,
            txn_id,
        })
            .pipe((0, operators_1.mergeMap)((mfaParams) => {
            return (0, rxjs_1.of)({}).pipe((0, operators_1.mergeMap)(() => this.verifyCaptcha(mfaParams)), (0, operators_1.mergeMap)(() => this.verifySecurityAccount(mfaParams)), (0, operators_1.mergeMap)(() => this.verifyPasskeyOrBiometrics(mfaParams)), (0, operators_1.mergeMap)(() => requestExecutor(mfaParams)));
        }))
            .pipe((0, operators_1.map)((data) => data))
            .subscribe(this.params.onSuccess, this.params.onError);
    }
}
exports.BasePasskeySession = BasePasskeySession;
